import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from "../../shared/common.service";

@Component({
  selector: 'app-study-crc-monitoring',
  templateUrl: './study-crc-monitoring.component.html',
  styleUrls: ['./study-crc-monitoring.component.scss']
})
export class StudyCRCMonitoringComponent implements OnInit {
  siteActivityChilds: any[] = [];
  selectedTab: string = '';
  form: FormGroup;
  dropdownOptions: { [key: string]: { [field: string]: any[] } } = {};
  routeParams: any;
  groupNames: { [key: string]: string } = {};
  multiForm: FormGroup;
  currentFormIndex = '';
  siteActivitesList = [
    {
      id: 1,
      name: "Site Monitoring Report",
      form: "Site_Monitoring_Report"
    },
    {
      id: 2,
      name: "CAPA Report",
      form: "CAPA_Report"
    },
    {
      id: 3,
      name: "Monitoring close out visits",
      form: "Monitoring_close_out_visits"
    }
  ];
  currentFormObject: { id: number; name: string; form: string; };
  queryParams: any;

  studyId: number;
  previousPage: number;
  currentPage: number = 1;
  searchParams: any = {}; // Store search params here
  searchCrcName: string = '';
  searchStudyName: string = '';
  searchLocation: string = '';
  searchAssignedBy: string = '';



  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
  ) {
    this.form = this.fb.group({
      selectedOption: [''],
      dynamicForm: this.fb.group({})
    });
    this.routeParams = this.route.snapshot.params;
    this.queryParams = this.route.snapshot.queryParams;
  }

  ngOnInit() {
    this.multiForm = this.fb.group({
      selectedOption: [''],  // Dropdown control
      "Site_Monitoring_Report": this.fb.group({
        "form1": this.fb.group({
          date: [''],
          reportLink:[''],
          comment: [],
        }),
        'form2': this.fb.group({
          comment: [''],
          date: [''],
          reportLink:[''],
        }),
        'form3': this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form4": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form5": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        })
      }),
      "CAPA_Report": this.fb.group({
        "form1": this.fb.group({
          date: [''],
          comment: [],
          reportLink:[''],
        }),
        "form2": this.fb.group({
          comment: [''],
          date: [''],
          reportLink:[''],
        }),
        "form3": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form4": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form5": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        })
      }),
      "Monitoring_close_out_visits": this.fb.group({
        "form1": this.fb.group({
          date: [''],
          comment: [],
          reportLink:[''],
        }),
        "form2": this.fb.group({
          comment: [''],
          date: [''],
          reportLink:[''],
        }),
        "form3": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form4": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        }),
        "form5": this.fb.group({
          comment: [],
          date: [''],
          reportLink:[''],
        })
      })
    });

    this.multiForm.get('selectedOption').valueChanges.subscribe((selectedValue) => {
      this.selectOption(selectedValue);
      //console.log(this.queryParams.selectedOption);
    });
    if (this.queryParams.selectedOption) {
      this.multiForm.get('selectedOption').setValue(this.queryParams.selectedOption);
      //console.log(this.queryParams.selectedOption);
    }
    let userData = this.commonService.getUserData();
    if (userData == null) {
      this.commonService.logout();
    }


this.studyId = +this.route.snapshot.paramMap.get('id');
// Capture the query parameters
this.route.queryParams.subscribe(params => {
 this.currentPage = params['page'] || 1;
 this.searchParams.searchCrcName = params['searchCrcName'] || '';
 this.searchParams.searchStudyName = params['searchStudyName'] || '';
 this.searchParams.searchLocation = params['searchLocation'] || '';
 this.searchParams.searchAssignedBy = params['searchAssignedBy'] || '';
});



  }

  selectOption(selectedValue) {
    this.selectedTab = selectedValue;
    //console.log(selectedValue);
    this.currentFormIndex = selectedValue;
    for (const element of this.siteActivitesList) {
      if (element.name == this.currentFormIndex) {
        this.currentFormObject = element;
      }
    }
    this.updateForm(selectedValue);
  }
  // Helper function to get the correct form group
  getFormGroupByIndex(index: any): FormGroup {
    const formNames = ['form1', 'form2', 'form3'];
    return this.multiForm.get(this.currentFormObject.form) as FormGroup;
  }

  submitDataToApi(data: any): void {
    // API call logic here
    console.log('Data submitted to the API:', data);
  }

  updateForm(optionId: string) {
    let params = new HttpParams()
      .set('id', optionId)
      .set('study_crc_id', this.routeParams.id);
    this.apiService.get('api/siteMonitoringChilds', params).subscribe(
      (response: any[]) => {
        this.siteActivityChilds = response;
        response.forEach(child => {
          if(optionId == 'Site Monitoring Report'){
            const cdaForm = this.multiForm.get('Site_Monitoring_Report') as FormGroup;
            const form1 = cdaForm.get(child.name) as FormGroup;
            form1.get('date').setValue(child?.data?.date || '');
            form1.get('comment').setValue(child?.data?.comment || '');
            form1.get('reportLink').setValue(child?.data?.reportLink || '');

          }else if(optionId == 'CAPA Report'){
            const cdaForm = this.multiForm.get('CAPA_Report') as FormGroup;
            const form1 = cdaForm.get(child.name) as FormGroup;
            form1.get('date').setValue(child?.data?.date || '');
            form1.get('comment').setValue(child?.data?.comment || '');
            form1.get('reportLink').setValue(child?.data?.reportLink || '');

          }else if(optionId == 'Monitoring close out visits'){
            const cdaForm = this.multiForm.get('Monitoring_close_out_visits') as FormGroup;
            const form1 = cdaForm.get(child.name) as FormGroup;
            form1.get('date').setValue(child?.data?.date || '');
            form1.get('comment').setValue(child?.data?.comment || '');
            form1.get('reportLink').setValue(child?.data?.reportLink || '');

          }
          // Trigger change detection to update visibility
          // this.updateVisibility(cdaForm.get('status').value);
        });
        this.multiForm.updateValueAndValidity();
      }
    );
  }

  onSubmit() {

    const currentForm = this.getFormGroupByIndex(this.currentFormIndex);

    if (currentForm.valid) {
      console.log('Submitted data:', currentForm.value);
      let formData = currentForm.value;
      const filteredForms = Object.keys(formData).reduce((acc, key) => {
        const form = formData[key];
        if (form.comment || form.date || form.reportLink) {
            acc[key] = form; // Add the form if at least one field is not empty
        }
        return acc;
    }, {});
      let finalData = { "dynamicForm": filteredForms };
      finalData["id"] = this.routeParams.id;
      finalData["selectedOption"] = this.selectedTab;
      console.log(finalData);
      // console.log(this.multiForm.value.selectedOption);
      this.apiService.post('api/createStudyCrcMonitoring', finalData).subscribe(response => {
        console.log('Form submitted successfully', response);
        window.alert(response.message);
        location.reload();
      });
      // You can submit the form or proceed further here
    } else {
      console.log('The current form is invalid');
    }
  }


goBack(): void {
  this.router.navigate(['/study-crc-list'], {
    queryParams: {
      page: this.currentPage,
      searchCrcName: this.searchParams.searchCrcName,
      searchStudyName: this.searchParams.searchStudyName,
      searchLocation: this.searchParams.searchLocation,
      searchAssignedBy: this.searchParams.searchAssignedBy
    }
  });
}




}
